import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import {environment} from "@src/environments/environment";

export interface NjuskaloPlace {
    id: number;
    name: string;
}

export interface NjuskaloCity {
    city: string;
    places: NjuskaloPlace[];
}

export interface NjuskaloRegion {
    region: string;
    cities?: NjuskaloCity[];
    places?: NjuskaloPlace[];
}

@Injectable({ providedIn: 'root' })
export class NjuskaloLocationApiService {
    private readonly treeUrl = `${environment.apiUrl}/api/integrations/njuskalo/location-tree`;

    // Static reference data — fetch the whole tree once and reuse for the app lifetime.
    private tree$?: Observable<NjuskaloRegion[]>;

    constructor(private http: HttpClient) {}

    getTree(): Observable<NjuskaloRegion[]> {
        if (!this.tree$) {
            this.tree$ = this.http.get<NjuskaloRegion[]>(this.treeUrl).pipe(shareReplay(1));
        }
        return this.tree$;
    }
}
